import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import { get, map, join, some, isEmpty } from 'lodash';
import { DetailsBlockRow, DetailsBlock } from './details-block';
import messages from '../../utils/messages';

class DetailsLeft extends Component {
  constructor(props) {
    super(props)
  };

  render() {
    const { recall } = this.props;
    const { formatMessage } = this.props.intl;

    const manufacturerCountries = join(map(get(recall, 'manufacturer.country', []), country => get(country, 'name')), ', ');

    return (
      <div className="col-sm-7">
        <DetailsBlock title={formatMessage(messages.recallDetails)} tableClass="table-merged table-rdetails step7b">
          <DetailsBlockRow label={formatMessage(messages.date)} data={get(recall, 'date')} noTranslate={true} thStyle={{ width: '25%' }}/>
          <DetailsBlockRow label={formatMessage(messages.recallCountryName)} data={get(recall, 'countryName')}/>
          <DetailsBlockRow label={formatMessage(messages.alert)} data={get(recall, 'extUrl')} noTranslate={true} type="providerLink"/>
          <DetailsBlockRow label={formatMessage(messages.manufacturerCountry)} data={manufacturerCountries} thStyle={{ width: '25%' }}/>
          <DetailsBlockRow label={formatMessage(messages.detailsManufacturerName)} data={get(recall, 'manufacturer.name')}/>
          <DetailsBlockRow label={formatMessage(messages.manufacturerWebsite)} data={get(recall, 'manufacturer.url')} noTranslate={true} type="providerLink"/>
        </DetailsBlock>

        <DetailsBlock title={formatMessage(messages.productDetails)} tableClass="table-merged step8">
          <DetailsBlockRow label={formatMessage(messages.type)} data={get(recall, 'product.type')} thStyle={{ width: '25%' }}/>
          <DetailsBlockRow label={formatMessage(messages.productName)} data={get(recall, 'product.name')} type="html"/>
          <DetailsBlockRow label={formatMessage(messages.description)} data={get(recall, 'product.desc')} type="html"/>
          <DetailsBlockRow label={formatMessage(messages.modelAndVolume)} data={get(recall, 'product.modelAndVolume')} type="html"/>
          <DetailsBlockRow label={formatMessage(messages.riskLevel)} data={get(recall, 'riskLevel')} rowClass="danger step11" renderNothingOnNoDataOrFalse={true}/>
          <DetailsBlockRow label={formatMessage(messages.hazard)} data={get(recall, 'hazard')} rowClass="danger" type="html"/>
          <DetailsBlockRow label={formatMessage(messages.injury)} data={get(recall, 'injuries')} type="html"/>
          <DetailsBlockRow label={formatMessage(messages.action)} data={get(recall, 'action')} rowClass="warning step12" type="html"/>
          <DetailsBlockRow label={formatMessage(messages.units)} data={get(recall, 'units')}/>
        </DetailsBlock>

        {some(['gtin', 'gtin.desc', 'gtin.product.type'], f => !isEmpty(get(recall, f))) &&
        <DetailsBlock title={formatMessage(messages.gtinParagraph)} tableClass="table-merged step9">
          <DetailsBlockRow label={formatMessage(messages.gtinNumber)} data={get(recall, 'gtin')} />
          <DetailsBlockRow label={formatMessage(messages.gtinDesc)} data={get(recall, 'gtin.desc')}/>
          <DetailsBlockRow label={formatMessage(messages.gtinProductType)} data={get(recall, 'gtin.product.type')}/>
        </DetailsBlock>
        }

        {some(['hts', 'hts.desc', 'hts.product.type'], f => !isEmpty(get(recall, f))) &&
        <DetailsBlock title={formatMessage(messages.htsParagraph)} tableClass="table-merged step9">
          <DetailsBlockRow label={formatMessage(messages.htsCode)} data={get(recall, 'hts')}/>
          <DetailsBlockRow label={formatMessage(messages.htsDesc)} data={get(recall, 'hts.desc')}/>
          <DetailsBlockRow label={formatMessage(messages.htsProductType)} data={get(recall, 'hts.product.type')}/>
        </DetailsBlock>
        }

        {some(['distributor.name', 'distributor.website'], f => !isEmpty(get(recall, f))) &&
        <DetailsBlock title={formatMessage(messages.distributorParagraph)} tableClass="table-merged step9">
          <DetailsBlockRow label={formatMessage(messages.distributorName)} data={get(recall, 'distributor.name')}/>
          <DetailsBlockRow label={formatMessage(messages.distributorWebsite)} data={get(recall, 'distributor.website')} noTranslate={true} type="providerLink"/>
        </DetailsBlock>
        }
      </div>
    );
  }
}

export default injectIntl(DetailsLeft);



// WEBPACK FOOTER //
// ./src/views/recall-details/details-left.js